var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForwardSearchHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4051_2662)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 19.5,
    r: 18.5,
    fill: "#2D76FD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4051_2662",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.46094,
    y: 7.01172,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4051_2662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0879 19.7607H13.7109C13.4981 19.7607 13.3199 19.6889 13.1764 19.5452C13.0328 19.4017 12.9609 19.2236 12.9609 19.0107C12.9609 18.7979 13.0328 18.6197 13.1764 18.4762C13.3199 18.3326 13.4981 18.2607 13.7109 18.2607H25.0879L19.9187 13.0915C19.77 12.9428 19.6966 12.7688 19.6984 12.5695C19.7004 12.3702 19.7789 12.1929 19.9339 12.0377C20.0891 11.8929 20.2648 11.8179 20.4609 11.8127C20.6571 11.8076 20.8328 11.8826 20.9879 12.0377L27.3282 18.378C27.4219 18.4717 27.4879 18.5704 27.5262 18.6742C27.5647 18.7781 27.5839 18.8902 27.5839 19.0107C27.5839 19.1312 27.5647 19.2434 27.5262 19.3472C27.4879 19.4511 27.4219 19.5498 27.3282 19.6435L20.9879 25.9837C20.8494 26.1222 20.6779 26.1931 20.4734 26.1962C20.2689 26.1994 20.0891 26.1286 19.9339 25.9837C19.7789 25.8286 19.7014 25.6504 19.7014 25.4492C19.7014 25.2479 19.7789 25.0697 19.9339 24.9145L25.0879 19.7607Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4051_2662",
    x: 0,
    y: 0,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4051_2662"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4051_2662",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardSearchHover);
export default __webpack_public_path__ + "static/media/arrow_forward_search_hover.7108f0bb384237a3c9ebcda993651eb7.svg";
export { ForwardRef as ReactComponent };